import React, {useReact} from 'react';
import { Row, Col } from 'react-bootstrap';

const View = (props) => {
    return (
        <div className="p-2">
            <div>
                Tanggal dikirim
            </div>
            <div>
                <b>{props.date} {props.time}</b>
            </div>
            
        </div>
    )
}

export default View